<div class="box">
  <div class="header">
    <div class="content" [ngClass]="'greendAnalityco' || 'primary'">
      {{ data.title }}
    </div>
  </div>

  <div class="content-card-Trainings" autocomplete="off">
    <form [formGroup]="questionForm"  class="training-form">
      <div class="sub-header">
        <div class="sub-content greendAnalityco">
          {{ 'CONTEXTO INICIAL' || 'N/A' }}
        </div>
      </div>
      <div class="sub-body">
        <span class="file-context-title">Archivo de texto, audio o video</span>
        <ng-container *ngIf="!hasExistingContextFile && files.length === 0">
          <ngx-dropzone
            (change)="onSelect($event, 'inicial')"
            class="dropzone dropzone-inicial"
            [multiple]="false"
            [class.disabled]="hasUrl"
            tabindex="0"
            style="margin-top: 17px; height: 95px; width: 280px;">
            <ngx-dropzone-label>
              Clic aquí ó arrastra y suelta un archivo
            </ngx-dropzone-label>
          </ngx-dropzone>

          <div>
            <span class="file-context-text">URL</span>
            <mat-form-field appearance="outline" class="url-field">
              <mat-icon matPrefix>link</mat-icon>
              <input
                style="margin-left: -17px;"
                matInput
                placeholder="Escribe o pega un vínculo de Youtube"
                formControlName="initialUrl"
                [disabled]="files.length > 0" />
            </mat-form-field>
          </div>
        </ng-container>

        <div *ngIf="!hasExistingContextFile && files.length > 0" class="uploaded-file">
          <span class="file-name">{{ files[0].name }}</span>
          <button mat-icon-button class="remove-button" (click)="clearInitialSelection()">
            <mat-icon>cancel</mat-icon>
          </button>
        </div>

        <div *ngIf="hasExistingContextFile" class="uploaded-file">
          <span class="file-name">{{ contextDisplayName }}</span>
          <mat-icon (click)="openUrl(dataEdit.ContextQuestion)" class="visibility-icon">visibility</mat-icon>
          <mat-icon (click)="deleteContextMedia(dataEdit.IdQuestion)" class="delete-icon">delete</mat-icon>
        </div>
      </div>
      <div class="sub-header-question" [ngClass]="{ 'edit-mode': dataEdit, 'create-mode': !dataEdit }"
           [ngStyle]="{ 'margin-top': hasExistingFile ? '0px' : '-21px' }">
        <div class="sub-content-1 greendAnalityco">
          {{ 'PREGUNTA' || 'N/A' }}
        </div>
      </div>
      <div>
        <label class="question-label">Texto de pregunta</label>
        <textarea
          maxlength="{{250}}"
          class="question-textarea"
          formControlName="Question"
          placeholder="Escribe aquí tu pregunta…">
        </textarea>
      </div>

      <div class="sub-header-correct-answer">
        <div class="sub-content-2 greendAnalityco">
          {{ 'RESPUESTA CORRECTA' || 'N/A' }}
        </div>
      </div>
      <div>
        <span class="file-context-question">
          Imagen opcion 1
        </span>
        <ngx-dropzone
          *ngIf="fileCorrectQuestion.length === 0 && !dataEdit?.CorrectAnswerImage"
          (change)="onSelect($event, 'correct')"
          class="dropzone dropzone-correct"
          [multiple]="false" [accept]="'image/*'"
          style="margin-top: 10px; height: 95px; width: 280px; margin-left: 12px;">
          <ngx-dropzone-label>
            Clic aquí ó arrastra y suelta un archivo
          </ngx-dropzone-label>
        </ngx-dropzone>

        <div *ngIf="fileCorrectQuestion.length > 0 && !dataEdit?.CorrectAnswerImage" class="uploaded-file-correct">
          <span class="file-name">{{ fileCorrectQuestion[0]?.name }}</span>
          <button mat-icon-button class="remove-button-correct" style="margin-top: -25px; margin-right: 12px;" (click)="removeFileCorrect()">
            <mat-icon >cancel</mat-icon>
          </button>
        </div>

        <div *ngIf="dataEdit?.CorrectAnswerImage" class="uploaded-file-correct">
          <span class="file-name">Imagen opción 1 </span>
          <img [src]="s3Bucket + dataEdit.CorrectAnswerImage" class="image-preview" alt="Imagen opción 1" />
          <mat-icon (click)="openUrl(dataEdit.CorrectAnswerImage)" class="visibility-icon">visibility</mat-icon>
          <mat-icon (click)="deleteQuestionAnswer(true)" class="delete-icon">delete</mat-icon>
        </div>

        <label class="question-label-2">Texto de respuesta correcta</label>
        <textarea
          maxlength="{{250}}"
          class="question-textarea-2"
          formControlName="respuestaCorrecta"
          placeholder="Escribe aquí tu respuesta correcta…">
        </textarea>
      </div>

      <div class="sub-header-incorrect-answer">
        <div class="sub-content-3 greendAnalityco">
          {{ 'RESPUESTA INCORRECTA' || 'N/A' }}
        </div>
      </div>
      <div>
        <span class="file-context-question-2">
          Imagen opcion 2
        </span>
        <ngx-dropzone
          *ngIf="fileIncorrectQuestion.length === 0 && !dataEdit?.ImageIncorrectAnswer"
          (change)="onSelect($event, 'incorrect')"
          class="dropzone dropzone-incorrect"
          [multiple]="false" [accept]="'image/*'"
          style="margin-top: 10px; height: 95px; width: 280px; margin-left: 12px;">
          <ngx-dropzone-label>
            Clic aquí ó arrastra y suelta un archivo
          </ngx-dropzone-label>
        </ngx-dropzone>

        <div *ngIf="fileIncorrectQuestion.length > 0 && !dataEdit?.ImageIncorrectAnswer" class="uploaded-file-incorrect">
          <span class="file-name">{{ fileIncorrectQuestion[0]?.name }}</span>
          <button mat-icon-button class="remove-button-incorrect" style=" margin-top: -25px; margin-right: 12px;" (click)="removeFileIncorrect()">
            <mat-icon>cancel</mat-icon>
          </button>
        </div>

        <div *ngIf="dataEdit?.ImageIncorrectAnswer" class="uploaded-file-incorrect">
          <span class="file-name">Imagen opción 2 </span>
          <img [src]="s3Bucket + dataEdit.ImageIncorrectAnswer" class="image-preview" alt="Imagen opción 2" />
          <mat-icon (click)="openUrl(dataEdit.ImageIncorrectAnswer)" class="visibility-icon">visibility</mat-icon>
          <mat-icon (click)="deleteQuestionAnswer(false)" class="delete-icon">delete</mat-icon>
        </div>

        <label class="question-label-3">Texto de respuesta incorrecta</label>
        <textarea
          maxlength="{{250}}"
          class="question-textarea-3"
          type="text"
          formControlName="respuestaIncorrecta"
          placeholder="Escribe aquí tu respuesta incorrecta…">
        </textarea>
      </div>

      <div class="question-order">
        <span class="label">Orden de la pregunta</span>
        <input
          type="number"
          min="1"
          class="input-order"
          formControlName="questionOrder"
          name="questionOrder" />
      </div>

      <div class="btn-actions">
        <button mat-button class="btn-cancelar" (click)="close()">
          {{ 'CANCELAR' }}
        </button>
        <button mat-button class="btn-generar" (click)="dataEdit ? saveEdit() : save()">
          {{ 'GUARDAR' }}
        </button>
      </div>
    </form>
  </div>
</div>
